<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">{{ userData.last_name + ' ' + userData.first_name }}</p>
      </div>
      <b-avatar
        :src="userData.avatar"
        class="user-avatar text-white"
        :badge-variant="avatarBadgeVariant"
        badge-offset="-12px"
        :title="subscriptionDaysTitle"
        :variant="userData.avatar ? 'light-primary' : 'secondary'"
      >
        <template
          v-if="subscriptionEndOf"
          #badge
        >
          <feather-icon
            icon="ClockIcon"
            size="12"
          ></feather-icon>
          <span class="ml-25 mr-25">{{ subscriptionDaysLabel }}</span>
        </template>
      </b-avatar>
    </template>

    <b-dropdown-item
      v-if="subscriptionEndOf"
      link-class="d-flex align-items-center"
      @click="goToSubscriptionManagePage"
    >
      <feather-icon
        size="16"
        icon="DollarSignIcon"
        class="mr-50"
      ></feather-icon>
      <span>Подписка</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      ></feather-icon>
      <span>Выйти</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BIconClockFill } from 'bootstrap-vue'
import store from '@/store/index'
import { avatarText } from '@/core/utils/filter'
import { getUserData } from '@/auth/utils'
import { computed } from 'vue'
import { subscriptionExpirationDate } from '@/composables/currentUser'
import moment from 'moment/moment'
import router from '@/router'

export default {
  components: { BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BIconClockFill },
  setup() {
    const userData = computed(() => getUserData())
    const subscriptionEndOf = computed(() => {
      const date = subscriptionExpirationDate()
      return date ? moment(date) : null
    })
    const subscriptionDays = computed(
      () => subscriptionEndOf.value ? subscriptionEndOf.value.diff(moment(), 'days') : 0
    )
    const subscriptionEndDate = computed(
      () => subscriptionEndOf.value ? subscriptionEndOf.value.format('LL') : null
    )
    const subscriptionDaysLabel = computed(
      () => `${subscriptionDays.value > 0 ? (subscriptionDays.value > 30 ? `30+` : subscriptionDays.value) : 0} д.`
    )
    const avatarBadgeVariant = computed(
      () => {
        let variant = 'success'
        if (subscriptionDays.value >= 15 && subscriptionDays.value < 30) {
          variant = 'warning'
        } else if (subscriptionDays.value < 15) {
          variant = 'danger'
        }
        return variant
      }
    )
    const subscriptionDaysTitle = computed(() => {
      let title = subscriptionDays.value < 1
        ? 'Внимание! Истек срок подписки!' : `Подписка активна до: ${subscriptionEndDate.value}`
      if (subscriptionDays.value > 0 && subscriptionDays.value < 15) {
        title = 'Внимание! Истекает срок подписки!'
      }
      if (!subscriptionEndOf.value) {
        title = null
      }
      return title
    })

    const logout = () => store.dispatch('auth/logout')
    const goToSubscriptionManagePage = () => router.push({name: 'apps-billing-statement'})

    return {
      subscriptionEndOf,
      subscriptionEndDate,
      subscriptionDays,
      subscriptionDaysLabel,
      subscriptionDaysTitle,
      avatarBadgeVariant,
      userData,
      avatarText,

      logout,
      goToSubscriptionManagePage
    }
  }
}
</script>

<style lang='scss'>

@import '@/assets/scss/variables/variables';

.dropdown-user {
  .dropdown-user-link {
    padding-right: 0 !important;

    .user-avatar {
      width: 40px !important;
      height: 40px !important;

      .b-avatar-badge {
        display: flex;
        align-items: center;
        bottom: -8px !important;
        right: 20px !important;
        color: $white;
      }

      @media screen and (max-width: 360px) {
        width: 30px !important;
        height: 30px !important;
      }

      @media screen and (max-width: 575px) {
        .b-avatar-badge {
          display: none;
        }
      }

      @media screen and (max-width: 768px) {
        .b-avatar-badge {
          padding: 3px;

          .feather {
            display: none;
          }
        }
      }
    }
  }
}

</style>
